"use strict";

const { default: Swal } = require("sweetalert2");
const config = require('../../../../../config/locales_json/packs/private/admin/local_careers.json');
const language = $('body').data("language");

var AdminCareersDatatable = function () {
  // Define shared variables
  var table = document.getElementById('kt_datatable_local_careers');
  var datatable;

  // Private functions
  var initCareersTable = function () {
      // Init datatable --- more info on datatables: https://datatables.net/manual/

      datatable = $(table).DataTable({
        info: true,
        order: [],
        pageLength: 10,
        lengthChange: false,
        searching: true,
        autoWidth: false, // Desactiva el ajuste automático de ancho
        responsive: true, // Opcional: hace que la tabla sea responsive
        columns: [
          { width: '65%' },
          { width: '10%' },
          { width: '10%' },
          { width: '15%' }
        ]
      });
  }

  // Search Datatable --- official docs reference: https://datatables.net/reference/api/search()
  var handleSearchDatatable = () => {
    const filterSearch = document.querySelector('[data-kt-careers-table-filter="search"]');
    filterSearch.addEventListener('keyup', function (e) {
      datatable.search(e.target.value).draw();
    });
  }
  
  var _deleteCareer = function() {
    $("#kt_datatable_local_careers").on("click", ".delete-button", function(e){
      $('#delete_local_career_modal').modal('toggle')
      // Obtiene el id de la carrera
      var localCareerID = $(this).attr("data-id")
      // Asigna el id de la carrera en el campo hidden del modal
      $("#delete_local_career_modal #hidden_modal_id").val(localCareerID)
      // Se asigna la url correspondiente
      var url = '/admin/carreras/'+ localCareerID;
      $("#form_modal_delete_local_career").attr("action", url)
      // Si la carrera se debe archivar porque tiene usuarios con la carrera asignada
      if($(this).hasClass("not-delete")){
          const descriptionText = getTranslationValue(config, [language, "click-delete-button", "description_text"], 'Esta carrera ya está asociada a un postulante, no se puede eliminar pero si quedará archivado. Esta acción no se puede revertir.');
          const btnText = getTranslationValue(config, [language, "click-delete-button", "btn_text"], 'Archivar');

          // Modifica la descripcion del modal
          $("#delete_local_career_modal .modal-body .description").text(descriptionText)
          // Modifica el texto del boton
          $("#delete_local_career_modal .modal-footer #send_modal_delete_local_career_form").text(btnText)
          // Agrega la clase not-delete para que al enviar el formulario muestre el texto de "Archivando..."
          $("#delete_local_career_modal .modal-footer #send_modal_delete_local_career_form").addClass("not-delete")
      // Si la carrera debe eliminarse modifica la info del modal por si anteriormente el modal fue abierto
      // por alguna carrera que se debio archivar
      } else {
          const descriptionText = getTranslationValue(config, [language, "click-delete-button", "else_description_text"], 'Esta acción no se puede revertir.');
          const btnText = getTranslationValue(config, [language, "click-delete-button", "else_btn_text"], 'Eliminar');

          // Modifica la descripcion del modal
          $("#delete_local_career_modal .modal-body .description").text(descriptionText)
          // Modifica el texto del boton
          $("#delete_local_career_modal .modal-footer #send_modal_delete_local_career_form").text(btnText)
          // Quita la clase not-delete para que al enviar el formulario muestre el texto de "Eliminando..."
          $("#delete_local_career_modal .modal-footer #send_modal_delete_local_career_form").removeClass("not-delete")
      }
    })

    // Al cerrar el modal limpia la url y el hidden
    $("#delete_local_career_modal .close").on("click", function(e){
        cleanLocalCareerModalFields()
    })

    // Al hacer click en confirmar eliminacion de universidad
    $("#delete_local_career_modal #cancel_modal_delete_local_career_form").on("click", function(e){
        cleanLocalCareerModalFields()
    })

    // Al hacer click en eliminar carrera
    $("#delete_local_career_modal #send_modal_delete_local_career_form").on("click", function(e){
      // Valida que el campo hidden tenga información
      var localCareerID = $("#delete_local_career_modal #hidden_modal_id").val()
      // Si tiene informacion ejecuta el formulario
      if(localCareerID.length > 0) {
        // Se desabilitan las acciones
        // Si se esta archivando una universidad
        if($(this).hasClass("not-delete")){
            const disabledText = getTranslationValue(config, [language, "click-modal-delete-local-career-form", "localCareerId-length-not-delete"], 'Archivando...');

            // Cambia el texto del boton a Archivando
            $(this).addClass("disabled").text(disabledText)
        // De lo contrario esta eliminando una universidad
        } else {
            const disabledText = getTranslationValue(config, [language, "click-modal-delete-local-career-form", "localCareerId-length-not-delete-else"], 'Eliminando...');

            // Cambia el texto del boton a Eliminando
            $(this).addClass("disabled").text(disabledText)
        }

        $("#delete_local_career_modal #cancel_modal_delete_local_career_form").addClass("disabled")
        $("#delete_local_career_modal #close_delete_local_career_modal").addClass("disabled")
        $("#form_modal_delete_local_career").submit()
      } else {
        const disabledText = getTranslationValue(config, [language, "click-modal-delete-local-career-form", "else-localCareerId-length"], 'Hubo un problema y no se pudo eliminar la carrera. Por favor intente más tarde.');
        // Si no se puede eliminar
        $(".modal-body").find(".error-modal").remove()
        $(".modal-body").prepend('<div class="error-modal"><i class="fas fa-times-circle"></i><p>'+disabledText+'</p></div>')
      }
    })

    // Limpia el campo hidden y la url del form
    function cleanLocalCareerModalFields(){
      // Limpia si hay errores
      $(".modal-body").find(".error-modal").remove()
      // Limpia el campo hidden
      $("#delete_local_career_modal #hidden_modal_id").val(null)
      // Se limpia la url correspondiente
      var url = '';
      $("#form_modal_delete_local_career").attr("action", url)
    }
  }

  return {
    // Public functions  
    init: function () {
      if (!table) {
          return;
      }

      initCareersTable();
      handleSearchDatatable();
      _deleteCareer();
      // Remueve el input de busqueda por defecto
      $(".dt-search").remove();
    }
  }
}();


jQuery(document).ready(function() {
  if($("#kt_datatable_local_careers").length > 0){
    AdminCareersDatatable.init();
  }
});

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}

	return currentTranslation;
}